(ns web3.react
  (:require ["react" :as react]
            [goog.object :as gobj]
            [clojure.string :as str]))

(defmulti component-lookup (fn [component key not-found] key))

(defmethod component-lookup :default
  [o k not-found]
  (or not-found
      (throw (ex-info (str "No lookup method provided for key " k) {:component o
                                                                    :key k
                                                                    :not-found not-found}))))

(extend-type react/Component
  IPrintWithWriter
  (-pr-writer [this writer opts]
    (-write writer (str "👁 " (-> (.. this -constructor -displayName)
                                  (str/replace #".*\.([^.]+/.*)$" "$1")))))
  ILookup
  (-lookup
    ([o k]
     (get o k nil))
    ([o k not-found]
     (component-lookup o k not-found))))
